import { FigmaTypography } from "@libs/zapi-ui/custom";
import { AiLogsView } from "./AiLogsView";

export function AiLogsPage() {
  return (
    <div className="container mx-auto py-8 pt-[95px] min-h-[calc(100vh-51px-64px)]" data-testid="ai-logs-page">
      <div className="flex justify-between items-center mb-6">
        <FigmaTypography component="h1" variant="heading-1" data-testid="ai-logs-heading">AI Logs</FigmaTypography>
      </div>

      <AiLogsView />
    </div>
  );
}
